import WebdavService, { IDadosProcesso } from './WebdavService';
import { IModelo, Minuta, Processo } from '../modelo';
import config from '../misc/Configuracao';
import fetch from './AxiosAdapter';
import MensagemStore from '../store/MensagemStore';
import { apresentarApiErroPadrao } from '@/utils/ApiErroPadraoUtils';

class MinutaWebdavApi {


    public async criarAPartirDeModelo(processo: Processo,
        minuta: Minuta,
        modelo: IModelo,
        login: string,
        edicaoExterna: boolean,
        edicaoAguia: boolean,
        funcaoSignatario?: string) {

        const dadosProcesso: IDadosProcesso = { processo, minuta, modelo, login, funcaoSignatario };
        const urlGravaMinuta = await WebdavService.urlHttp(dadosProcesso);
        try {
            const documento = await fetch(urlGravaMinuta, { responseType: 'arraybuffer',
            silent: edicaoAguia});

            await fetch(urlGravaMinuta + `?edicaoExterna=${edicaoExterna}&edicaoAguia=${edicaoAguia}`,
                {
                    method: 'PUT',
                    body: documento.data,
                    headers: { 'Content-Type': 'application/xml' }
                });
        } catch (error) {

            if (!edicaoAguia) {
                throw error;
            }

            const data = error?.response?.data;

            let mensagemErro: string | undefined;

            if (data instanceof ArrayBuffer) {
                mensagemErro = new TextDecoder('utf-8').decode(data);
            } else if (typeof data === 'string') {
                mensagemErro = data;
            }

            MensagemStore.apresentarErro(
                mensagemErro || 'Erro ao gerar minuta.'
            );
        }
    }

    async recuperaTokenMinuta(idProcesso, idTipoMinuta, gabinete: string, edicao: boolean = false) {
        try {
            const result = await fetch((edicao ? config.urlWebDAV : config.urlBaseMinuta) + 'webdav/token?idProcesso=' + idProcesso + '&idTipoMinuta=' + idTipoMinuta + "&gabinete=" + gabinete, {
                withCredentials: true,
                method: 'GET',
                cache: 'no-store'
            });
            if (result.status < 200 || result.status > 299) {
                throw new Error(result.statusText);
            }
            return result.data;
        } catch (e) {
            console.error(e);
            if (!apresentarApiErroPadrao(e)) {
                MensagemStore.apresentarErro("Erro ao recuperar token para abrir minuta no Word.");
            }
        }
    }
}

export default new MinutaWebdavApi();
